"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCK_TYPE_LABELS = exports.BLOCK_TYPES_BY_REPORT = exports.REPORT_TYPE_LABELS = exports.REPORT_COLLECTION_BY_TYPE = exports.DEFAULT_COMPANY_SETTINGS = exports.DEFAULT_COMPANY_LOGO_URL = void 0;
exports.getReportBlockPlaceCount = getReportBlockPlaceCount;
exports.getReportBlockQuantity = getReportBlockQuantity;
exports.calculateReportBlockLineTotal = calculateReportBlockLineTotal;
exports.getTemplatePlacement = getTemplatePlacement;
exports.calculateCosts = calculateCosts;
exports.DEFAULT_COMPANY_LOGO_URL = 'https://multitan.co.il/images/multitan_logo.png';
exports.DEFAULT_COMPANY_SETTINGS = {
    defaultCurrency: 'ILS',
    vatRate: 0.18,
    unexpectedRate: 0.05,
    supervisionRate: 0.10,
};
exports.REPORT_COLLECTION_BY_TYPE = {
    bedek: 'bedek_reports',
    retivut: 'retivut_reports',
    yad2: 'yad2_reports',
};
exports.REPORT_TYPE_LABELS = {
    bedek: 'בדק בית',
    retivut: 'רטיבות',
    yad2: 'בדק בית יד 2',
};
function getReportBlockPlaceCount(block) {
    const counts = Object.values(block.placeCounts ?? {});
    const total = counts.reduce((sum, count) => sum + (Number.isFinite(count) && count > 0 ? count : 0), 0);
    return total > 0 ? total : 1;
}
function getReportBlockQuantity(block) {
    if (block.amount > 1) {
        return block.amount;
    }
    const hasPlaceCounts = Object.values(block.placeCounts ?? {}).some((count) => Number.isFinite(count) && count > 0);
    return hasPlaceCounts
        ? getReportBlockPlaceCount(block)
        : 1;
}
function calculateReportBlockLineTotal(block, basePrice) {
    const customPrice = block.price ?? 0;
    const quantity = getReportBlockQuantity(block);
    if (customPrice > 0) {
        return Math.round(customPrice * quantity);
    }
    return Math.round(basePrice * quantity);
}
const LEGACY_PRE_CONTENT_WP_IDS = new Set([12889, 63110, 12926, 7562, 59188, 368031]);
// Shared by Backoffice and Reportan Mobile so both offer the same report headers. Legacy
// WordPress templates carry no placement: pre-content bodies are listed by ID, the rest are headers.
function getTemplatePlacement(template) {
    if (template.placement)
        return template.placement;
    if (template.type === 'post')
        return 'post';
    return template.wpId !== null && LEGACY_PRE_CONTENT_WP_IDS.has(template.wpId) ? 'pre' : 'header';
}
// Helper function: Calculate costs
function calculateCosts(blocks, defects, settings) {
    let subtotal = 0;
    for (const block of blocks) {
        if (block.type === 'defect' && block.defectRef) {
            const defect = defects.get(block.defectRef);
            if (defect) {
                subtotal += calculateReportBlockLineTotal(block, defect.price);
            }
        }
    }
    const unexpected = subtotal * settings.unexpectedRate;
    const supervision = (subtotal + unexpected) * settings.supervisionRate;
    const vat = (subtotal + unexpected + supervision) * settings.vatRate;
    const total = subtotal + unexpected + supervision + vat;
    return {
        subtotal: Math.round(subtotal),
        unexpected: Math.round(unexpected),
        supervision: Math.round(supervision),
        vat: Math.round(vat),
        total: Math.round(total),
    };
}
// Block type availability per report type
exports.BLOCK_TYPES_BY_REPORT = {
    bedek: ['defect', 'location', 'page_break', 'gallery'],
    retivut: ['defect', 'location', 'page_break', 'gallery'],
    yad2: ['location', 'bdika', 'defect', 'siba', 'recommendation', 'comment', 'gallery', 'page_break'],
};
// Hebrew labels for block types
exports.BLOCK_TYPE_LABELS = {
    defect: 'ליקוי',
    location: 'מיקום',
    siba: 'סיבה',
    bdika: 'בדיקה',
    recommendation: 'המלצה',
    comment: 'הערה',
    page_break: 'דף חדש',
    gallery: 'גלריה',
};
